(function(angular){
	'use strict';
	
	angular.module('amountSelectModule', [
		'angular.filter',
		'BaseConfig',
		'bigModule',
		'eventsModule',
		'formValidationModule'
	]);

})(window.angular);